export const validateUserName = (userName, t) => {
  if (!userName || userName.trim() === "") {
    return { isValid: false, errorMessage: t("registrationForm.validation.nameRequired") };
  }

  const nameParts = userName.trim().split(/\s+/);

  if (nameParts.length < 2) {
    return { isValid: false, errorMessage: t("registrationForm.validation.fullNameRequired") };
  }

  const namePattern = /^[A-Za-zА-Яа-яӘәІіҢңҒғҮүҰұҚқӨөҺһ]+(-[A-Za-zА-Яа-яӘәІіҢңҒғҮүҰұҚқӨөҺһ]+)*$/;

  for (const part of nameParts) {
    if (!namePattern.test(part)) {
      return {
        isValid: false,
        errorMessage: t("registrationForm.validation.nameFormat"),
      };
    }
  }

  return { isValid: true, errorMessage: null };
};

export const validatePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return false;

  const digitsOnly = phoneNumber.replace(/\D/g, '');
  return digitsOnly.length >= 11 && digitsOnly.length <= 13;
};

export const validateBinLength = (bin) => {
  return bin && bin.length === 12;
};

export const validateCompanyName = (companyName) => {
  const namePattern = /^[A-Za-zА-Яа-яӘәІіҢңҒғҮүҰұҚқӨөҺһ]/;
  return namePattern.test(companyName);
};

export const parseFullName = (fullName) => {
  if (!fullName) {
    return { surname: "", name: "", patronymic: "" };
  }

  const names = fullName.trim().split(/\s+/);
  return {
    surname: names[0] || "",
    name: names[1] || "",
    patronymic: names.length > 2 ? names[2] : "",
  };
};
